import { PlatoLogoWithText } from '@/assets/icons/plato-logo-with-text';
import { Button } from '@/components/ui/button';
import { ChevronsLeft } from 'lucide-react';
import type { FC } from 'react';
import { Link } from 'react-router-dom';
import type { NavPathOverrideEnum } from '../contracts';
import { CreateNewMenu } from './create-new-menu';
import { GlobalSearchBar } from './global-search-bar';
import { NavigationList } from './navigation-list';

export interface FullWidthNavProps {
    isDesktopScreenSize: boolean;
    closeDrawer: () => void;
    setSmallScreenDrawOpen: (open: boolean) => void;
    setDesktopSidebarOpen: (open: boolean) => void;
}

export const FullWidthNav: FC<FullWidthNavProps> = ({
    isDesktopScreenSize,
    closeDrawer,
    setSmallScreenDrawOpen,
    setDesktopSidebarOpen,
}) => {
    return (
        <div className="flex h-full flex-col items-start bg-neutral-50 gap-3 p-3 pl-2">
            <div className="relative flex w-full shrink-0 items-center justify-between h-8">
                <Link to="/" className="flex px-1 h-8 items-center">
                    <PlatoLogoWithText className="h-7" />
                </Link>
                {isDesktopScreenSize ? (
                    <Button size="icon-s" variant="outline" onClick={() => setDesktopSidebarOpen(false)}>
                        <ChevronsLeft className="flex h-4 w-4 shrink-0 " />
                    </Button>
                ) : (
                    <Button size="icon-s" variant="outline" onClick={() => setSmallScreenDrawOpen(false)}>
                        <ChevronsLeft className="flex h-4 w-4 shrink-0 " />
                    </Button>
                )}
            </div>
            <div />
            <div className="flex w-full flex-col gap-3 overflow-y-auto h-full">
                <div className="w-full">
                    <GlobalSearchBar showFullInput />
                </div>
                <div className="w-full">
                    <CreateNewMenu onClose={closeDrawer} showFullInput />
                </div>
                <NavigationList closeDrawer={closeDrawer} />
            </div>
        </div>
    );
};
